export const candidateAge = (
  dateOfBirth?: string | null,
  fallback?: number | null,
  today = new Date(),
): number | null => {
  if (!dateOfBirth) return fallback ?? null;
  const [year, month, day] = dateOfBirth.split('-').map(Number);
  if (!year || !month || !day) return fallback ?? null;
  return today.getFullYear() - year - (
    today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day) ? 1 : 0
  );
};

export const formatBirthDate = (dateOfBirth?: string | null): string => {
  if (!dateOfBirth) return 'дата рождения не указана';
  const [year, month, day] = dateOfBirth.split('-');
  return year && month && day ? `${day}.${month}.${year}` : 'дата рождения не указана';
};

export const todayDateInput = (): string => {
  const today = new Date();
  return [
    today.getFullYear(),
    String(today.getMonth() + 1).padStart(2, '0'),
    String(today.getDate()).padStart(2, '0'),
  ].join('-');
};
